module.exports = __webpack_public_path__ + "static/media/lushan_web.8bc8d62d.png";